export const config = {
  title: 'Add Notes & Share',
  okText: 'Save & Share',
  width: 480,
  fields: [
    {
      name: 'notes',
      type: 'mention-textarea',
      required: true,
      rows: 5,
      placeholder: "Add your notes on the job. Use '@' to mention someone.",
      mentionFetchKey: 'mentionUsers',
    },
  ],
};
